const MODAL_TYPES = {
  WINDOW: 'window',
  BANNER: 'banner',
  POPUP: 'popup',
  TOOLTIP: 'tooltip',
};

export default MODAL_TYPES;
